import React from 'react';
import TableRow from './TableRow';
import { TABLE_HEADER } from '@constants/customPage';
import { IPageContent } from './type';

interface ITableProps {
  customPage: IPageContent[];
  pageType: string;
}

const Table = ({ customPage, pageType }: ITableProps) => {
  return (
    <div className="tw-m-4">
      <h1 className="tw-mb-4">{pageType}</h1>
      <table className="tw-w-full tw-border-collapse">
        <thead>
          <tr>
            <th className="tw-w-2/6">{TABLE_HEADER.pageName}</th>
            <th>{TABLE_HEADER.id}</th>
            <th>{TABLE_HEADER.prismicLink}</th>
            {pageType === 'LandingPage' && (
              <th title="The fields Title and Description are used here to defined the SEO status">
                {TABLE_HEADER.seo}
              </th>
            )}
            <th>{TABLE_HEADER.updated}</th>
          </tr>
        </thead>
        <tbody>
          {customPage.map((pageContent: IPageContent) => (
            <TableRow key={pageContent.uid} pageContent={pageContent} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
